import { render, staticRenderFns } from "./Interventions.vue?vue&type=template&id=2ef4e4e0&"
import script from "./Interventions.vue?vue&type=script&lang=js&"
export * from "./Interventions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports